/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PrimeDatatableParams } from '../../models/prime-datatable-params';
import { WebUrlViewModelPrimeDatatableResults } from '../../models/web-url-view-model-prime-datatable-results';

export interface ListWebUrls$Params {
      body?: PrimeDatatableParams
}

export function ListWebUrls(http: HttpClient, rootUrl: string, params?: ListWebUrls$Params, context?: HttpContext): Observable<StrictHttpResponse<WebUrlViewModelPrimeDatatableResults>> {
  const rb = new RequestBuilder(rootUrl, ListWebUrls.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<WebUrlViewModelPrimeDatatableResults>;
    })
  );
}

ListWebUrls.PATH = '/api/Developer/ListWebUrls';
